<template>
    <div class="solution">
      <div class="main">
        <div class="bg1">
          <div class="model1">
            <p class="position">您所在的位置：首页 > 智慧工地</p>
            <p class="title">什么是公路工程智慧工地质量管控系统</p>
            <p class="title2"></p>
            <div class="model1-main">
              <div class="left">
                <p>1、公路工程智慧工地质量管控系统是通过物联网技术，为公路工程施工的各个环节（拌合楼生产环节、运输环节、摊铺和碾压环节）的数据和质量问题提供先进的技术手段，构建智能监控和防范体系，有效弥补传统方法和技术在监管中的缺陷，实现对人员、机械、材料、环境的全方位实时动态数据监控。</p>
                <p>2、质量管控系统是智慧工地理念在公路工程领域的行业具现，是一种崭新的工程全生命周期管理理念。质量管控系统是指运用信息化手段，通过硬件和软件以及5G技术对工程施工（拌合楼生产环节、运输环节、摊铺和碾压）环节进行数据采集和精确计算，围绕施工过程管理，建立互联协同、智能分析、精准监测的施工理念，并将此数据在现实环境下与物联网采集到的工程信息进行数据挖掘分析，提供过程趋势预测及专家指导和精准告警，实现工程施工可视化的智能监测管理，提高工程施工质量和管理信息化水平，从而逐步实现绿色建造和生态建造。</p>
                <p>3、质量管控系统融入了更多的人工智能、传感技术、虚拟现实等高科技技术植入到拌合楼生产、运输、摊铺、碾压施工环节中，并且被全程互联，形成“物联网”，再与“互联网”整合在一起，实现工程管理干系人与工程施工现场的整合。质量管控的核心是以一种“更智慧”的方法来改进工程各干系组织和施工环节相互交互的数据监测方式，以便提高监测的精准性、效率、灵活性和响应速度。</p>     
              </div>
              <div class="right">
                <img class="scale" :src="url + '/assets/solution/site-platform.png'">
              </div>
            </div>
          </div>
        </div>
        <div class="bg2">
          <div class="model2">
            <div class="model1-main">
              <div class="left">
                <p class="title">质量管控系统介绍</p>
                <div class="title2"></div>
                <div class="p">公路工程智慧工地质量管控平台是江苏交控科技有限公司基于公路工程施工现场的实际需求进行深度挖掘，结合先进的计算机、云计算、大数据、物联网、移动互联网、人工智能等技术手段，引领智慧工地细分市场的发展，通过运用公路工程智慧工地管控平台，解决施工现场管理难、监督难、施工难，施工环节的信息数据采集不健全等问题。</div>
              </div>
              <div class="right">
                <img class="scale" :src="url + '/assets/solution/site-system.png'">
              </div>
            </div>
          </div>
         </div>
         <div class="bg1">
          <div class="model3">
            <div class="model1-main">
              <div class="right">
                <img class="scale" :src="url + '/assets/solution/site-framework.png'">
              </div>
               <div class="left">
                <p class="title">产品系统架构</p>
                <div class="title2"></div>
                <div class="p">公路工程智慧工地质量管控平台是江苏经世交通科技有限公司基于公路工程施工现场的实际需求进行深度挖掘，结合先进的计算机、云计算、大数据、物联网、移动互联网、人工智能等技术手段，引领智慧工地细分市场的发展，通过运用公路工程智慧工地管控平台，解决施工现场管理难、监督难、施工难，施工环节的信息数据采集不健全等问题。</div>
                <div class="p">公路工程智慧工地管控平台包含Web端及APP端，其中，Web平台以系统的配置、数据的采集及分析为核心，满足不同角色的功能及数据的差异化展现，为项目管理者、监理公司、施工单位等角色提供对应的管理支持及数据服务。App端基于移动办公、无纸化办公的理念，提供面向项目管理者、监理人员、施工单位等业务功能，满足随时随地查看、跟踪、处理各施工环节业务的需求，帮助客户提高管理效率和提升施工质量。</div>
              </div>
            </div>
          </div>
         </div>
        <div class="bg2">
          <div class="model4">
            <p class="title">数据监测-拌合楼生产环节</p>
            <div class="title2"></div>
            <div class="model1-main">
              <div class="right">
                <img class="scale" :src="url + '/assets/solution/site-plant.png'">
              </div>      
              <div class="left">
                <div class="p">后场数据监测主要从以下几个方面对拌合楼生产进行的实时动态的数据监测：</div>
                <div class="p1"><img :src="url + '/assets/solution/transport-one.png'"><span>拌合楼当前时段是否处于开机生产状态</span></div>
                <div class="p1"><img :src="url + '/assets/solution/transport-two.png'"><span>实时采集并展示拌合楼当前生产的混合料数据</span></div>
                <div class="p1"><img :src="url + '/assets/solution/transport-three.png'"><span>对重要的指标参数如：油石比、合成级配、筛孔通过率、温度、每盘料的拌和周期等数据进行实时监测与展示</span></div>
              </div>
            </div>
          </div>
         </div>
          <div class="bg1">
            <div class="model5">
              <p class="title">数据监测-运料车运输环节</p>
              <div class="title2"></div>
              <div class="model1-main">
                <div class="left">
                  <div class="p">运输数据监测主要从以下几个方面对运输环节进行的实时动态的数据监测：</div>
                  <div class="p1"><img :src="url + '/assets/solution/transport-one.png'"><span>正在接料的运输车实时数量</span></div>
                  <div class="p1"><img :src="url + '/assets/solution/transport-two.png'"><span>在途的运料车数量</span></div>
                  <div class="p1"><img :src="url + '/assets/solution/transport-three.png'"><span>正在卸料的运料车数量</span></div>
                  <div class="p1"><img :src="url + '/assets/solution/transport-four.png'"><span>运料车的运行轨迹</span></div>
                  <div class="p1"><img :src="url + '/assets/solution/transport-five.png'"><span>运料车运输时间</span></div>
                </div>
                <div class="right">
                  <img class="scale" :src="url + '/assets/solution/site-transport.png'">
                </div>
              </div>
            </div>
         </div>
         <div class="bg2">
          <div class="model6">
            <p class="title">数据监测-摊铺和碾压环节</p>
            <div class="title2"></div>
            <div class="model1-main">
              <div class="right">
                <img class="scale" :src="url + '/assets/solution/site-paving.png'">
              </div>      
              <div class="left">
                <div class="p">前场数据监测主要从以下几个方面对摊铺和碾压环节进行的实时动态的数据监测：</div>
                <div class="p1"><img :src="url + '/assets/solution/transport-one.png'"><span>现场环境监测数据：包含风速、温度、PM2.5、PM10、风向、大气压力等</span></div>
                <div class="p1"><img :src="url + '/assets/solution/transport-two.png'"><span>摊铺机当前的速度、温度、温度离析；碾压速度、温度等数据</span></div>
                <div class="p1"><img :src="url + '/assets/solution/transport-three.png'"><span>摊铺温度实时分析、摊铺速度实时分析</span></div>
                <div class="p1"><img :src="url + '/assets/solution/transport-four.png'"><span>碾压温度实时分析、碾压速度实时分析</span></div>
              </div>
            </div>
          </div>
         </div>
      </div>
       <foot></foot>
    </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
import foot from '../components/foot'
export default {
  data() {
    return {
      url: defaultSettings.url,
    }
  },
  components: {
    foot
  },
  mounted() {
    window.scrollTo({ left: 0, top: 0 })
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>

.bg1{
  background: #F9F9F9;
}
.bg2{
  background: #fff;
}
.title{
  color:#333;
  font-size:34px;
  text-align: left;
}
.title2:after {
  display: block;
  content: "";
  height: 0;
  line-height: 0;
  visibility: hidden;
  clear: both;
}
.title2 {
  zoom: 1; /* 为了兼容IE */
}
.title2{
  width: 87px;
  height: 3px;
  background: #167EFB;
  text-align: left;
  margin:30px 0 25px;
  display: block;
}
// 缩放
.scale{
    width:100%;
    transition: all 0.6s;
}
.scale:hover{
    transition: all 0.6s;
    transform: scale(1.08);
}

.solution{
  padding-top:140px;
  background: #F9F9F9;
  .main{
    .model1{
      margin-top:84px;
      width:1200px;
      margin: 0 auto;
      .position{
        margin-top:25px;
        color:#999999;
        font-size:14px;
        margin-bottom:50px;
      }
      .title{
        color:#333;
        font-size:34px;
        text-align: center;
      }
      .title2{
        width: 87px;
        height: 3px;
        background: #167EFB;
        text-align: center;
        margin:30px auto 0;
      }
      .model1-main{
        padding-bottom:95px;
        display: flex;
         margin-top:60px;
        .left{
          width:518px;
          // height:500px;
          p{
            font-size:14px;
            color:#666;
            margin-bottom:10px;
            line-height: 30px;
          }
          // @media screen and (max-width: 1500px) {
          //     p {
          //        line-height: 25px;
          //     }
          // }
        }
        .right{
          width:594px;
          height:500px;
          margin-left:80px;
          img{
            width:594px;
            height:500px;
          }
        }
      }
    }
    .model2{
      width:1200px;
      margin: 0px auto;
      padding-top:80px;
      .model1-main{
        padding-bottom:95px;
        display: flex;
        .left{
          width:378px;
          .p{
            font-size:14px;
            color:#666;
            margin-bottom:10px;
            line-height: 30px;
          }
        }
        .right{
          width:723px;
          height:594px;
          margin-left:80px;
          margin-top:10px;
          img{
            width:723px;
            height:594px;
          }
        }
      }
    }
    .model3{
      width:1200px;
      margin: 0px auto;
      padding-top:80px;
      .model1-main{
        padding-bottom:95px;
        display: flex;
        .left{
          width:420px;
           margin-left:80px;
          .p{
            font-size:14px;
            color:#666;
            margin-bottom:10px;
            line-height: 30px;
          }
        }
        .right{
          width:668px;
          height:559px;
          margin-top:10px;
          img{
            width:668px;
            height:559px;
          }
        }
      }
    }
    .model4{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .model1-main{
        padding-bottom:95px;
        display: flex;
        .left{
          width:360px;
          margin-left:20px;
          margin-top:30px;
          .p{
            font-size:18px;
            color:#333;
            margin-bottom:30px;
            line-height: 30px;
          }
          .p1{
            margin-bottom:15px;
            line-height: 30px;
            img {
              width:14px;
              height:15px;
              vertical-align: middle;
              margin-right:18px;
            }
            span{
              font-size:14px;
              color:#666;
              width:322px;
              display: inline-block;
              vertical-align: top;
            }
          }
        }
        .right{
           width:816px;
            height:526px;
          img{
            width:816px;
            height:526px;
          }
        }
      }
    }
    .model5{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .model1-main{
        padding-bottom:95px;
        display: flex;
        .left{
          width:360px;
          margin-top:30px;
          .p{
            font-size:18px;
            color:#333;
            margin-bottom:30px;
            line-height: 30px;
          }
          .p1{
            margin-bottom:15px;
            line-height: 30px;
            img {
              width:14px;
              height:15px;
              vertical-align: middle;
              margin-right:18px;
            }
            span{
              font-size:14px;
              color:#666;
              width:322px;
              display: inline-block;
              vertical-align: top;
            }
          }
        }
        .right{
           margin-left:20px;
           width:822px;
            height:556px;
          img{
            width:822px;
            height:556px;
          }
        }
      }
    }
     .model6{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .model1-main{
        padding-bottom:95px;
        display: flex;
        .left{
          width:360px;
          margin-left:20px;
          margin-top:30px;
          .p{
            font-size:18px;
            color:#333;
            margin-bottom:30px;
            line-height: 30px;
          }
          .p1{
            margin-bottom:15px;
            line-height: 30px;
            img {
              width:14px;
              height:15px;
              vertical-align: middle;
              margin-right:18px;
            }
            span{
              font-size:14px;
              color:#666;
              width:322px;
              display: inline-block;
              vertical-align: top;
            }
          }
        }
        .right{
           width:816px;
            height:526px;
          img{
            width:816px;
            height:526px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/solution.vue